import { DualColor } from "../types";

export const secondary: DualColor = {
  light: "#f43f5e",
  dark: "#dc004e"
};
